import React, {useEffect, useState} from 'react';
import ChildContext from "root/Contexts/ChildContext";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const ChildProvider = ( { child_id, children } ) => {

    const [ isPost16, setPost16 ] = useState ( false ) ;
    const [ isNEET, setNEET ] = useState ( false ) ;

    const [data, setData] = useState({isLoading: true, child: []});

    useEffect(() =>
    {
        if (child_id !== undefined && child_id !== null && child_id !== 0)
        {
            getChildData( child_id );
        }
    }, [child_id]);

    const getChildData = ( cur_child_id ) =>
    {
        const flags = [ 'include-needs', 'include-flags', 'include-esw' ] ;

        setData({isLoading: true, child: []});

        getChildDetails( cur_child_id, flags, (response) =>
        {
            const recs = getDataFromResponse(response) ;

            const rec = recs[0] ;

            const isSixteen = +(rec.is_post_sixteen) === 1 ;

            const isNeet = +(rec.es_type) === 2 ;

            setPost16 ( isSixteen ) ;
            setNEET ( isNeet ) ;
            setData({isLoading: false, child: rec});
        });

    }

    const isSenK = () =>
    {
        if (data.child.needs == null)
        {
            if (+(data.child.sen_k_flag) === 1)
            {
                return true ;
            }
            else
            {
                return false ;
            }
        }
        else
        {
            return false ;
        }
    }

    const isSen = () =>
    {
        if (data.child.needs == null)
        {
            return false ;
        }
        else
        {
            return true ;
        }
    }

    return (
        <ChildContext.Provider
            value={{
                isPost16: isPost16,
                isNEET: () =>
                {
                    return isNEET ;
                },
                setPost16: ( flag ) =>
                {
                   setPost16( flag ) ;
                },
                isSenK: () =>
                {
                    return isSenK() ;
                },
                isSen: () =>
                {
                    return isSen() ;
                },
                getChildData: ( new_child_id ) =>
                {
                    getChildData ( new_child_id );
                },
                year_group_id: data.child?.year_group_id,
                child: data.child,
                isLoading: data.isLoading,
            }}
        >
        {children}
        </ChildContext.Provider>
    )
}

export default ChildProvider;